import Menu from "../../../components/Menu/Menu";
import NotAuthenticated from "../../../components/NotAuthenticated/NotAuthenticated";
import useAuth from "../../../hooks/useAuth";
import './Evcars.scss';

export default function Evcars() {
    const authenticated = useAuth();
    if (authenticated === false)
        return <NotAuthenticated/>;

    return (
        <div id = "evcars">
            <div className="centered-container">
                <Menu title="EV Cars" options={[
                    { name: 'Races', path: '/misc/evcars/races' },
                    { name: 'Database', path: '/misc/evcars/database' },
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
}